import type { FaireProductEntity } from "../../entity_types/product";

export const p_6n3acgn3tz: FaireProductEntity = {
  token: "p_6n3acgn3tz",
  type: "product",
  name: "White Water Nylon Hat (FW26 Pre-order)",
  brandToken: "b_409pab9jko",
  brandName: "Belong Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/10be6045166d7126b082ca769c6d7e8fc21e14c348988fad29b89d4a4b1e0b8e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/05925975bf34f2ca49275dc111ef8a04fabe91c88266abf28d67dfe20bb45d86.jpeg",
    "https://cdn.faire.com/fastly/e25411c02e83219de730e214a4de356409bb72aabf580542732517af110ddb20.jpeg",
    "https://cdn.faire.com/fastly/7a6c1461eb50124ae4b985745518a78e8637e1a235062a903df762e25313c59a.jpeg",
    "https://cdn.faire.com/fastly/b0cfd17707ed206fe31dd8b424728c1a80c76130e4ce8132c3113a14895248c7.png",
    "https://cdn.faire.com/fastly/4947fc923a1c4ec27fc903b74d82cfe06041739d4e9ada93c8bc0348115038f5.png",
    "https://cdn.faire.com/fastly/4286a72b5490bb71f223bae91c9bc80d75c1467b0cc7e6f616ec8703ae542336.png",
    "https://cdn.faire.com/fastly/42cb2f6f408f4d4f3696a0b83a09bb8dca04c2571437345f2f32ed2f45fb2c0c.png",
    "https://cdn.faire.com/fastly/0dbdcd66a05c02250eb5f10c18c8174b39e36f443ce0219071fd9ae9a79db355.png",
    "https://cdn.faire.com/fastly/85ae46768411a87532798cd5a4aebb3efb0c8e5824fa6823a942ed84de0f0e9f.png",
    "https://cdn.faire.com/fastly/b8d02be4f883bcf8804d02ebb4bb65970eafa77ec7e233e018456bb0bfab82de.jpeg",
    "https://cdn.faire.com/fastly/d2d581a318659582881c3063d7c896bca0ff9fe1ea9b5fe840744f1251aa361c.jpeg",
    "https://cdn.faire.com/fastly/56644cb2fb3df8dc99a95d7efcc29faf8f0ad540429078856517993a43a4e845.jpeg",
    "https://cdn.faire.com/fastly/9d21cbaf27011843803cdfce45eb3fcef2508ec6437043efa1e1bf06454997d1.jpeg",
    "https://cdn.faire.com/fastly/4f70647ca62a2a1298bb8c69b9f27340daf69fc88a44145d3c29508dd9514cbd.jpeg",
    "https://cdn.faire.com/fastly/de81ffd2c18fb970a682f333622e65bbc9273f867accc9b2b1b3a4838ca924a6.jpeg",
    "https://cdn.faire.com/fastly/53b741a343c1fe2098f7044815087199f419797457518d2e0e8603f2a994a2ad.jpeg",
  ],
  priceDollars: 22.17,
  description:
    "Not just your normal hats - these hats are built to perform, look good, and feel better. Get outside and adventure everywhere.",
  tags: [],
  msrpDollars: 44.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:47.956Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
